"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Square(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19 3c.522 0 1.055.191 1.432.568.377.377.568.91.568 1.432v14c0 .522-.191 1.055-.568 1.432-.377.377-.91.568-1.432.568H5c-.522 0-1.055-.191-1.432-.568C3.191 20.055 3 19.522 3 19V5c0-.522.191-1.055.568-1.432C3.945 3.191 4.478 3 5 3zm0 2H5v14h14V5zm-4.004 2.402v1.589h-3.817l-.237 2.063a3.02 3.02 0 0 1 1.444-.362c.914 0 1.63.283 2.149.85.518.567.777 1.36.777 2.38 0 .62-.13 1.174-.392 1.664-.261.49-.636.87-1.124 1.14-.488.27-1.063.406-1.727.406-.58 0-1.118-.118-1.615-.353a2.865 2.865 0 0 1-1.176-.992 2.704 2.704 0 0 1-.459-1.457h1.886c.04.4.179.711.418.933.24.222.553.333.94.333.43 0 .762-.155.995-.465.233-.31.35-.748.35-1.315 0-.545-.135-.962-.403-1.252-.268-.29-.648-.435-1.14-.435-.453 0-.82.118-1.101.356l-.185.171-1.516-.376.554-4.878h5.379z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Square;
